/**
 * Logic taken from:
 * https://github.com/validatorjs/validator.js
 */

import {urlRemoveQueryString} from '../url-utils/url-utils';
import {videoServiceIsValidUrl, VideoServices} from '../video-services-utils/video-services-utils';

export {validateIsUuid} from './validate-is-uuid'
export {validateIsHexColor} from './validate-is-hex-color'
export {validateIsFQDN} from './validate-is-fqdn'
export {validateIsEmail} from './validate-is-email'
export {validateIsIp} from './validate-is-ip'
export {validateIsUrl} from './validate-is-url'
export {validateIsMobilePhone} from './validate-is-mobile-phone'
export {validateIsSlug} from './validate-is-slug'

export function validateIsDomain (
    domain: string
) {
    return /^(?!:\/\/)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(domain);
}


export function doppeValidateCalednlyCalendarURL(url: string) {
    const pattern = /^https:\/\/calendly\.com\/[^/]+(\/[^/]+)+\/?$/;
    return pattern.test(urlRemoveQueryString(url));
}

export function doppeValidateCalednlyProfileURL(url: string) {
    const profilePattern = /^https:\/\/calendly\.com\/[^/]+\/?$/;
    return profilePattern.test(urlRemoveQueryString(url));
}

export function doppeValidateAppleMusicURL(url: string) {
    return url.startsWith('https://music.apple.com/') || url.startsWith('https://podcasts.apple.com/');
}

export function doppeValidateTwitterUrl(url: string) {
    return doppeValidateTweetURL(url) || doppeValidateTwitterProfileURL(url);
}

export function doppeValidateTweetURL(url: string) {
    const twitterTweetPattern = /^https?:\/\/(www\.)?(x\.com|twitter\.com)\/[^/]+\/status\/\d+/;
    return twitterTweetPattern.test(urlRemoveQueryString(url));
}

export function doppeValidateTwitterProfileURL(url: string) {
    // Regular expression to match Twitter user profile URLs
    const twitterAccountPattern = /^https?:\/\/(www\.)?(x\.com|twitter\.com)\/[^/]+$/;

    return twitterAccountPattern.test(urlRemoveQueryString(url));
}

export function doppeValidateYoutubeShortURL(url: string) {
    const pattern = /^https?:\/\/(www\.)?youtube\.com\/shorts\/[a-zA-Z0-9_-]+/;

    return pattern.test(urlRemoveQueryString(url));
}

export function doppeValidateYoutubeVideoURL(url: string) {
    return videoServiceIsValidUrl(VideoServices.Youtube, url);
}